import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { Loading } from "components/Loading/loading";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { UnitDictionary } from "pages/InventoryAndSales/Inventory/BaseDefinitionAndSetting/Unit/components/UnitDictionary";
import { useContext, useEffect, useState } from "react";
import { ICON_TYPE, INVENTORYANDSALES_URL } from "utils/constants";
import {
  FloorWithRoundingPlace,
  RoundWithRoundingPlace,
  trans,
  uuidv4,
} from "utils/helpers";

import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { PriceInput } from "components/PriceInput/PriceInput";
import { ItemsForSell } from "pages/InventoryAndSales/Sales/components/ItemsForSell/ItemsForSell";
import { PriceDetails } from "pages/InventoryAndSales/Sales/components/PriceDetails";
import { MessageType } from "types/enum";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { getCustomerPriceListDetail } from "./api";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";

interface CustomerSalesOrderFormProps {
  onHide: () => void;
  CustomerSalesOrderDetailCallBack?: (e: any) => void;
  selectedObj?: any;
  mode: any;
  priceList?: any;
  lastWarehouse?: any;
  OrderConstraint?: any;
  HasWarehouseDetail?: any;
  setLastWarehouse: (e: any) => void;
  CustomerSalesWarehouse: any;
  personId?: any;
}

export const CustomerSalesOrderDetailForm = ({
  lastWarehouse = null,
  OrderConstraint,
  setLastWarehouse,
  HasWarehouseDetail,
  priceList,
  selectedObj,
  mode,
  onHide,
  CustomerSalesOrderDetailCallBack,
  CustomerSalesWarehouse,
  personId,
}: CustomerSalesOrderFormProps) => {
  const [resetForm, setResetForm] = useState(false);
  const [loading, setLoading] = useState<any>(true);
  const [userChanges, setUserChanges] = useState({});
    const layoutContext = useContext(LayoutContext);
  
  const [showTree, setShowTree] = useState<any>();
  const [priceListDetail, setPriceListDetail] = useState<any>([]);
  const [detailPriceData, setDetailPriceData] = useState<any>({
    TotalPrice: 0,
    Discount: 0,
    SubTotalPrice: 0,
    TaxRate: 0,
    CustomerDiscount: 0,

    Qty: mode != "create" ? selectedObj?.Qty : null,
  });
  const [warehouseData, setWarehouseData] = useState<any>(lastWarehouse);

  const [itemData, setItemData] = useState<any>(null);
  const [rate, setRate] = useState<any>(1);
  const [dictionaryName, setDictionaryName] = useState<any>({});
 const [itemSearch, setItemSearch] = useState<any>("");

  const [save_Exit, setSave_Exit] = useState<boolean>(false);

  const handleCustomerSalesOrderFormSubmit = async (event) => {
    event.preventDefault();
    let data = {
      Id: mode != "create" ? selectedObj?.Id : uuidv4(),
      CustomerSalesOrderId: selectedObj?.CustomerSalesOrderId,
      ItemId: itemData?.ItemId,
      UnitId:
        event.target.UnitId?.value == "" ? null : event.target.UnitId?.value,
      SourceId: selectedObj?.SourceId,
      SourceData: selectedObj?.SourceData,
      Item: itemData.ItemDescription,
      ItemCode: itemData?.Code,
      Qty: +event.target.Qty?.value,
      UnitPrice: +event.target.UnitPrice?.value.replaceAll(",", ""),
      Unit: dictionaryName?.Unit ? dictionaryName?.Unit : null,
      TotalPrice: OrderConstraint.IsFiscal
        ? +event.target.TotalPrice?.value.replaceAll(",", "")
        : undefined, //تخفیف کم میشود
      Discount: OrderConstraint.IsFiscal
        ? +event.target.Discount?.value.replaceAll(",", "")
        : undefined,
        CustomerDiscount: !OrderConstraint.IsFiscal
        ? undefined
        :event.target.CustomerDiscount? +event.target.CustomerDiscount?.value.replaceAll(",", ""):0,
        CustomerDiscountPercent: !OrderConstraint.IsFiscal
        ? undefined
        :event.target.CustomerDiscountPercent?.value?+event.target.CustomerDiscountPercent?.value :0,
      SubTotalPrice: OrderConstraint.IsFiscal
        ? +event.target.SubTotalPrice?.value.replaceAll(",", "")
        : undefined,
      Description: event.target.Description?.value,
      //      DescriptionEN: event.target.DescriptionEN.value,
      Tax: !OrderConstraint?.HasTax
        ? 0
        : !OrderConstraint.IsFiscal
        ? undefined
        : parseFloat(event.target.Tax?.value.replace(/,/g, "")),
      TaxRate: !OrderConstraint.HasTax
        ? 0
        : !OrderConstraint.IsFiscal
        ? undefined
        : detailPriceData.TaxRate,
      DiscountPercent: OrderConstraint.IsFiscal
        ? +event.target.DiscountPercent?.value.replaceAll(",", "")
        : undefined,
      ItemTechnicalCode: event.target.ItemTechnicalCode?.value,
      QtyRoundingPlace:
        priceListDetail[0]?.Qty1RoundingPlace ?? selectedObj?.Qty1RoundingPlace,
      WarehouseId: CustomerSalesWarehouse ?? null,
      WarehouseDetailId: HasWarehouseDetail
        ? warehouseData.WarehouseDetailId ?? null
        : null,
           GrandTotalPrice: !OrderConstraint.IsFiscal
            ? 0
            :
  
            +event.target.GrandTotalPrice.value.replaceAll(",", ""), 
    };

    CustomerSalesOrderDetailCallBack && CustomerSalesOrderDetailCallBack(data);
    setItemData(null);
    setResetForm(true);
    setUserChanges({});
    setDetailPriceData({
      TotalPrice: 0,
      Discount: 0,
      SubTotalPrice: 0,
      CustomerDiscount: 0,

      Qty: mode != "create" ? selectedObj?.Qty : 1,
    });
    sessionStorage.setItem("changingforms", "false");

    try {
    } catch (error) {}
    if (save_Exit) {
      onHide();
    }
  };

  const itemCodeHandeler = (obj, bool) => {
    if (obj.IsLeaf || bool) {
      setItemData({...obj,ItemId:obj?.Id});
     setDetailPriceData({
        TotalPrice: 0,
        Discount: 0,
        SubTotalPrice: 0,
        Qty1: 1,
        Qty2: 1,
        TaxRate: 0,
      });
      getPriceListDetailAsync(obj.Id);
      setShowTree(false);
    } else {
      // Toast(trans("msg_itemleafisnotselected"), "error");
      Toast(trans("msg_itemleafisnotselected"), MessageType.error);
    }
  };

  function cancel() {
    if (sessionStorage.getItem("changingforms") + "" == "true") {
      // Toast(trans("modalclosemessage"), "warning", "alertWithoutClose", () => {
      //   sessionStorage.setItem("changingforms", "false");
      //   setUserChanges({});
      //   onHide();
      // });
      Toast(trans("modalclosemessage"), MessageType.confirm, () => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
        onHide();
      });
    } else {
      onHide();
    }
  }

  const getPriceListDetailAsync = async (Id = null, Code = null) => {
    // setLoading(false)
    try {
      const res = await getCustomerPriceListDetail(
        Id,
        priceList,
        Code,
        CustomerSalesWarehouse,
        warehouseData?.WarehouseDetailId ?? null
      );
      if (res.Data && res.Data[0]) {
        setRate(res.Data[0]?.ConversionRatio);
      }
      const newPriceListDetail = res.Data?.ItemPriceList.map((item) => {
        return {
          ...item,
ItemId: res.Data.ItemId,
 MainUnitId: res.Data.MainUnitId,
        StatisticalUnitId: res.Data.StatisticalUnitId,
        PriceListUnitId: res.Data.PriceListUnitId,
        ItemDescription:res.Data.ItemDescription,
        ItemDescriptionEN: res.Data.ItemDescriptionEN,
        ItemCode: res.Data.ItemCode,
        ItemTechnicalCode: res.Data.ItemTechnicalCode,
        HasProductTracking: res.Data.HasProductTracking,
        HasExpireDate: res.Data.HasExpireDate,
        HasSerial: res.Data.HasSerial,
        IsAbsoluteUnitConversionRatio: res.Data.IsAbsoluteUnitConversionRatio,
        ConversionRatio: res.Data.ConversionRatio,
        PriceRoundingPlace: res.Data.PriceRoundingPlace,
        Qty1RoundingPlace: res.Data.Qty1RoundingPlace,
        Unit2: res.Data.Unit2,
        Unit2EN: res.Data.Unit2EN,
        Qty2RoundingPlace: res.Data.Qty2RoundingPlace,
ItemTaxList:res.Data.ItemTaxList,
ItemStockList:res.Data.ItemStockList,




          SalesUnitMaxOrderQty:
            res.Data.SalesUnitId === res.Data.MainUnitId
              ? item.Unit1MaxOrderQty
              : item.Unit2MaxOrderQty,
          SalesUnitMinOrderQty:
            res.Data.SalesUnitId === res.Data.MainUnitId
              ? item.Unit1MinOrderQty
              : item.Unit2MinOrderQty,
          SalesUnitPrice:
            res.Data.SalesUnitId === res.Data.MainUnitId
              ? item.Unit1Price
              : item.Unit2Price,
          SalesUnitId: res.Data.SalesUnitId,
          SalesUnitDiscount:
            res.Data.SalesUnitId === res.Data.MainUnitId
              ? item.Unit1Discount
              : item.Unit2Discount,
          QtyRoundingPlace:
            res.Data.SalesUnitId === res.Data.MainUnitId
              ? res.Data.Qty1RoundingPlace
              : res.Data.Qty2RoundingPlace,
        };
      });
      setPriceListDetail(newPriceListDetail);
      setItemData({
        ...itemData,
        ItemDescription: res.Data.ItemDescription,
        ItemId: res.Data.ItemId,
        Code: res.Data.ItemCode,
      });
      if (!OrderConstraint?.IsFiscal)
        setDetailPriceData((pre) => {
          return { ...pre, UnitId: newPriceListDetail[0].SalesUnitId };
        });
      // changeQty(res.Data[0].SalesUnitMinOrderQty, res.Data, totalTaxRate);
    } catch {
      setItemSearch(Code);
      setShowTree(true)
    }
  };

  const changeQty = (newQty: any, PriceList = [], tax: any = null) => {
    let newDetailPriceData: any = null;

    if (
      !priceListDetail.length &&
      mode === "edit" &&
      !OrderConstraint?.PriceListIsManual
    ) {
      //این شرط برای اولین بار است که ادیت میزنیم و لیست قیمت نداریم پس باید لیست قیمت بگیریم و کلا از تابع بریم بیرون چون با ست شدن لیست قیمت دوباره وارد همین تابع میشیم
      setDetailPriceData({
        ...detailPriceData,
        Qty: RoundWithRoundingPlace(newQty, selectedObj.QtyRoundingPlace),
      }); //برای وقتی که مود ادیت هست و برای بار اول به تعداد یکی اضافه میکنیم چون این تابع ریترن داره و مقدار با عدد جدید ست نمیشه اینجا ست میکنیم.
      getPriceListDetailAsync(detailPriceData.ItemId);
      return null; // to not go continue function beacuse this function set priceListDetail to causes to run useEffect and run changeQty
    }

    if (
      OrderConstraint?.PriceListHasDetailRang &&
      priceListDetail[priceListDetail.length - 1]?.SalesUnitMaxOrderQty + 1 ===
        detailPriceData.Qty &&
      priceListDetail[priceListDetail.length - 1]?.SalesUnitMaxOrderQty !== null
    ) {
      // در لیست قیمت بازه ای اگر  مود ادیت است و اولین بار هست که قراره به مقدار یکی اضافه بشه باید تشخیص بدهیم مقدار جدید از ماکسیمم لیست قیمت بیشتر نشود
      newQty = newQty - 1;
    }

    if (!OrderConstraint?.PriceListIsManual && OrderConstraint?.IsFiscal) {
      [...priceListDetail].reverse().map((e) => {
        if (
          (+e.SalesUnitMaxOrderQty >= newQty || e.MaxOrderQty == null) &&
          +e.SalesUnitMinOrderQty <= newQty
        ) {
          newDetailPriceData = e;
        }
      });
    } else {
      newDetailPriceData =
        priceList?.length > 0 ? PriceList[0] : priceListDetail[0];
      newDetailPriceData = {
        ...detailPriceData,
        ...newDetailPriceData,
        SalesUnitPrice: detailPriceData.UnitPrice,
        DiscountPercent: detailPriceData?.DiscountPercent,
      };
    }

    const totalTaxRate = TaxHandler(priceListDetail?.[0]?.ItemTaxList);
let totalPrice=0
       const discount=RoundWithRoundingPlace(
          (+newQty *
            (+newDetailPriceData?.SalesUnitPrice *
              (+newDetailPriceData?.DiscountPercent))) /
            100,
      OrderConstraint?.PriceRoundingPlace
          
        );

        const customerDiscount=RoundWithRoundingPlace(
        (+newQty * +newDetailPriceData?.SalesUnitPrice *(newDetailPriceData.CustomerDiscountPercent/100)),
      OrderConstraint?.PriceRoundingPlace
        
      );


         if(  (newDetailPriceData?.CustomerDiscountPercent && newDetailPriceData?.CustomerDiscountPercent !=0 )){
             const totalDiscount=discount+customerDiscount
      
              totalPrice =    RoundWithRoundingPlace(
                (+newQty *+newDetailPriceData?.SalesUnitPrice ) -totalDiscount ,
               OrderConstraint?.PriceRoundingPlace,
                
              );
      
            }else{
              totalPrice =    RoundWithRoundingPlace(
                (+newQty *+newDetailPriceData?.SalesUnitPrice ) -discount ,
               OrderConstraint?.PriceRoundingPlace,
                
              );
            }
    
    setDetailPriceData((pre) => {
      return {
        TotalPrice:
          newDetailPriceData?.SalesUnitPrice == -1
            ? 0
            :totalPrice,

        Discount: discount,
           CustomerDiscount: customerDiscount,
        CustomerDiscountPercent:newDetailPriceData?.CustomerDiscountPercent,
        SubTotalPrice:
          newDetailPriceData?.SalesUnitPrice == -1
            ? 0
            : +newQty * +newDetailPriceData?.SalesUnitPrice,
        Qty:
          ((+newDetailPriceData?.SalesUnitMaxOrderQty >= newQty ||
            newDetailPriceData?.SalesUnitMaxOrderQty == null) &&
            +newDetailPriceData?.SalesUnitMinOrderQty <= newQty) ||
          (priceList && priceList?.IsManual)
            ? RoundWithRoundingPlace(
                newQty,
                priceListDetail[0].QtyRoundingPlace ??
                  selectedObj.QtyRoundingPlace
              )
            : RoundWithRoundingPlace(
                pre.Qty,
                priceListDetail[0].QtyRoundingPlace ??
                  selectedObj.QtyRoundingPlace
              ),
        ItemTechnicalCode: newDetailPriceData?.ItemTechnicalCode,
        MaxOrderQty: newDetailPriceData?.SalesUnitMaxOrderQty,
        MinOrderQty: newDetailPriceData?.SalesUnitMinOrderQty,
        QtyMainUnit: newDetailPriceData?.QtyMainUnit,
        QtyStatisticalUnit: newDetailPriceData?.QtyStatisticalUnit,
        IsAbsoluteUnitConversionRatio:
          newDetailPriceData?.IsAbsoluteUnitConversionRatio,
        PriceListId: newDetailPriceData?.PriceListId,
        UnitDiscount: newDetailPriceData?.SalesUnitDiscount,
        UnitId: newDetailPriceData?.SalesUnitId,
        UnitPrice: newDetailPriceData?.SalesUnitPrice,
        TaxRate: OrderConstraint?.HasTax ? totalTaxRate : 0,
        DiscountPercent: newDetailPriceData?.DiscountPercent,
        GrandTotalPrice:newDetailPriceData?.SalesUnitPrice==-1?0:   totalPrice + (((OrderConstraint.HasTax  && mode!='view') || mode=='view' ? totalTaxRate : 0) *  +totalPrice) / 100 ,
      };
    });
  };

  const TaxHandler = (list) => {
    let totalTaxRate = 0;
    list?.map((item) => {
      totalTaxRate += item.TaxRate;
    });
    return totalTaxRate;
  };

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };
  const initializeFormWithSelectedObject = () => {
    setItemData({
      ...selectedObj,
      Code: selectedObj.ItemCode,
      ItemDescription: selectedObj.Item,
    });
    setDetailPriceData({
      ...selectedObj,
      TaxRate:
        (OrderConstraint.HasTax && mode != "view") || mode == "view"
          ? selectedObj.TaxRate
          : 0,
      SalesUnitMaxOrderQty: null,
      SalesUnitMinOrderQty: 1,
      MaxOrderQty: null,
      MinOrderQty: 1,
      TotalPrice: selectedObj.TotalPrice ? selectedObj.TotalPrice : selectedObj.Price,
      SalesUnitPrice:
        selectedObj.SalesUnitId === selectedObj.Unit1Id
          ? selectedObj.Unit1Price
          : selectedObj.Unit2Price,
      SalesUnitId:
        selectedObj.SalesUnitId === selectedObj.Unit1Id
          ? selectedObj.Unit1Id
          : selectedObj.Unit2Id,
      SalesUnitDiscount: selectedObj.Discount,
         CustomerDiscount:selectedObj.CustomerDiscount,
      CustomerDiscountPercent:selectedObj.CustomerDiscountPercent,
    });
  };

  useEffect(() => {
    if (selectedObj?.Id && mode !== "create") {
      initializeFormWithSelectedObject();
    }
  }, []);

  useEffect(() => {
    if (Object.values(userChanges).filter((item) => item != null).length > 0) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    } else {
      sessionStorage.setItem("changingforms", "false");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [userChanges]);

  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);

  useEffect(() => {
    if (mode == "edit" && !!priceListDetail.length) {
      changeQty(
        selectedObj.ItemId == itemData.ItemId
          ? detailPriceData.Qty
          : priceListDetail[0]?.SalesUnitMinOrderQty?priceListDetail[0]?.SalesUnitMinOrderQty:1,
        priceListDetail
      );
    }
    if (mode == "create" && !!priceListDetail.length) {
      changeQty(
        priceListDetail[0]?.SalesUnitMinOrderQty
          ? priceListDetail[0]?.SalesUnitMinOrderQty:
           1,
        priceListDetail
      );
    }
  }, [priceListDetail]);

  return (
    <div className="card " style={{ flexDirection: "row" }}>
      {showTree && (
        <ModalForm
          mode={mode}
          title="ItemTree"
          onHide={() => setShowTree(false)}
          show={showTree}
        >
          <ItemsForSell
            IsCustomer={true}
            priceListId={priceList}
            warehouseDetailId={warehouseData?.WarehouseDetailId ?? null}
            warehouseId={CustomerSalesWarehouse}
            onHide={() => {
              setShowTree(false);
            }}
            itemCodeHandeler={itemCodeHandeler}
            isFiscal={OrderConstraint.IsFiscal}
            searchString={itemSearch}

          />
        </ModalForm>
      )}

      <div style={{ flexWrap: "nowrap" }} className="card-body row">
        <div
          className={`card-body ${
            !!priceListDetail.length
              ? "col-12 col-md-7 col-lg-8 col-xl-9"
              : "col-12"
          }`}
        >
          {loading ? (
            <div className="container-fluid">
              <form onSubmit={handleCustomerSalesOrderFormSubmit}>
                <div className="row">
                  <>
                    {HasWarehouseDetail && (
                      <div className="col-lg-2 col-11">
                        <DictionarySelectBox
                          name="WarehouseDetail"
                          label="WarehouseDetail"
                          params={{ warehouseId: CustomerSalesWarehouse }}
                          onChange={(e, obj) => {
                            setWarehouseData((prev) => {
                              return {
                                ...prev,
                                WarehouseDetailId: e,
                                WarehouseDetail: obj?.Name,
                              };
                            });
                            if(warehouseData?.WarehouseDetailId){

                              setDetailPriceData({
                                TotalPrice: 0,
                                Discount: 0,
                                SubTotalPrice: 0,
                                TaxRate: 0,
                              });
                              setItemData({})
                            }
                          }}
                          baseUrl={INVENTORYANDSALES_URL}
                          endPoint={
                            ENDPOINTSINVENTORYANDSALES.Inventory
                              .BaseInformationApi.WarehouseDetail.dictionary
                          }
                          value={
                            mode != "create"
                              ? selectedObj?.WarehouseDetailId
                              : null
                          }
                          resetForm={resetForm}
                          mode={mode}
                        />
                      </div>
                    )}
                  </>
                  <div
                    className="col-md-3 col-sm-12"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <Textbox
                      required
                      onBlurHandler={(e) => {
                        if (e && e != itemData?.Code) {
                          getPriceListDetailAsync(null, e);
                        }
                      }}
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      onChange={(e) => {
                        if (
                          e?.target.value === null ||
                          e?.target.value === ""
                        ) {
                          setDetailPriceData({
                            TotalPrice: 0,
                            Discount: 0,
                            SubTotalPrice: 0,
                            Qty: mode != "create" ? selectedObj?.Qty1 : 1,
                          });
                          setPriceListDetail([]);
                          setItemData({});
                          setRate(null);
                          setItemSearch("")
                        }
                        else {
                          if (
                            // e.target.value != itemData?.Code &&
                            e.target.value.length > 2 )
                         if(isNaN(e.target.value) )    {
                           
                           setShowTree(true);
                         }
                            setItemSearch(e.target.value);
                        }

                      }}
                      textboxName={"itemCode"}
                      textboxType="text"
                      resetForm={resetForm}
                      labelText={"itemCode"}
                      mode={mode}
                      value={itemData?.Code}
                      defaultValue={itemData?.Code}
                    />
                    {mode != "view" && (
                      <div style={{ marginTop: "4px", width: "10%" }}>
                        <Button
                          Icon={true}
                          value={
                            <button
                              onClick={(e) => setShowTree(true)}
                              type="button"
                              className="checkButton"
                            >
                              {" "}
                              <FontAwesomeIcon
                                icon={[ICON_TYPE, "diagram-project"]}
                                size="1x"
                              />
                            </button>
                          }
                          btnType="primary"
                          onClick={(e) => setShowTree(true)}
                        />
                      </div>
                    )}
                  </div>

                  {itemData && itemData?.ItemDescription && (
                    <div className="col-md-4">
                      <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName="ItemDescription"
                        textboxType="text"
                        labelText="ItemReview"
                        value={itemData?.ItemDescription}
                        defaultValue={itemData?.ItemDescription}
                        resetForm={resetForm}
                        mode={"view"}
                        required={false}
                      />
                    </div>
                  )}

                  <div className="col-md-2">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="ItemTechnicalCode"
                      textboxType="text"
                      labelText="TechnicalCode"
                      value={detailPriceData.ItemTechnicalCode + ""}
                      defaultValue={
                        detailPriceData?.ItemTechnicalCode
                          ? detailPriceData?.ItemTechnicalCode
                          : null
                      }
                      resetForm={resetForm}
                      mode="view"
                      required={false}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      customClass={"arrow-none"}
                      step={
                        10 **
                        (priceListDetail[0]?.QtyRoundingPlace ??
                          selectedObj?.QtyRoundingPlace)
                      }
                      textboxName="Qty"
                      textboxType="number"
                      labelText="Qty"
                      value={
                        detailPriceData?.Qty
                          ? detailPriceData.Qty
                          : !!priceListDetail.length &&
                            priceListDetail[0]?.SalesUnitMinOrderQty
                          ? priceListDetail[0]?.SalesUnitMinOrderQty
                          : 1 + ""
                      }
                      defaultValue={
                        detailPriceData?.Qty
                          ? detailPriceData.Qty
                          : !!priceListDetail.length &&
                            priceListDetail[0]?.SalesUnitMinOrderQty
                          ? priceListDetail[0]?.SalesUnitMinOrderQty
                          : 1 + ""
                      }
                      usePrevDefaultValue={
                        OrderConstraint.PriceListHasDetailRange &&
                        priceListDetail[priceListDetail.length - 1]
                          ?.SalesUnitMaxOrderQty === detailPriceData.Qty
                      }
                      min={
                        priceListDetail.length > 0
                          ? priceListDetail[0]?.SalesUnitMinOrderQty
                            ? priceListDetail[0]?.SalesUnitMinOrderQty
                            : 10 **
                              (priceListDetail[0]?.QtyRoundingPlace ??
                                selectedObj?.QtyRoundingPlace)
                          : 10 **
                            (priceListDetail[0]?.QtyRoundingPlace ??
                              selectedObj?.QtyRoundingPlace)
                      }
                      max={
                        priceListDetail.length > 0
                          ? priceListDetail[priceListDetail.length - 1]
                              ?.SalesUnitMaxOrderQty
                          : undefined
                      }
                      decimals={priceListDetail[0]?.Unit1RoundingPlace}
                      resetForm={resetForm}
                      mode={mode}
                      required={true}
                      onChange={(e) => {
                        changeQty(+e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <UnitDictionary
                      returnObj
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      value={detailPriceData?.UnitId}
                      label="Unit"
                      name="UnitId"
                      required={false}
                      mode={"view"}
                      resetForm={resetForm}
                      setUnitDictionary={(e) => {
                        setDictionaryName({ ...dictionaryName, Unit: e.Value });
                      }}
                    />
                  </div>

                  <div className="col-md-3">
                    {/* <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="UnitPrice"
                      textboxType="text"
                      labelText="UnitPrice"
                      value={detailPriceData?.UnitPrice}
                      round={false}
                      defaultValue={
                        (detailPriceData?.UnitPrice
                          ? detailPriceData?.UnitPrice
                          : 0) + ""
                      }
                      resetForm={resetForm}
                      mode={"view"}
                      useGroupingPrice={true}
                      onChange={(e) =>
                        setDetailPriceData({
                          ...detailPriceData,
                          UnitPrice: +e.target.value.replaceAll(",", ""),
                          SubTotalPrice:
                            +e.target.value.replaceAll(",", "") *
                            detailPriceData.Qty,
                        })
                      }
                      required={false}
                    /> */}
                    <PriceInput
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      name="UnitPrice"
                      label="UnitPrice"
                      value={detailPriceData?.UnitPrice}
                      round={false}
                      defaultValue={
                        (detailPriceData?.UnitPrice
                          ? detailPriceData?.UnitPrice
                          : 0) + ""
                      }
                      resetForm={resetForm}
                      mode={"view"}
                      onChange={(e) =>
                        setDetailPriceData({
                          ...detailPriceData,
                          UnitPrice: +e.target.value.replaceAll(",", ""),
                          SubTotalPrice:
                            +e.target.value.replaceAll(",", "") *
                            detailPriceData.Qty,
                        })
                      }
                      required={false}
                    />
                  </div>
                  {OrderConstraint?.IsFiscal && (
                    <div className="col-md-3">
                      {/* <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="SubTotalPrice"
                      textboxType="text"
                      labelText="مبلغ"
                      value={detailPriceData?.SubTotalPrice+''}
                      round={false}
                      defaultValue={
                        detailPriceData?.SubTotalPrice || detailPriceData?.SubTotalPrice==0
                          ? detailPriceData?.SubTotalPrice + ""
                          : ""
                      }
                      resetForm={resetForm}
                      mode={"view"}
                      useGroupingPrice={true}
                      required={false}
                    /> */}
                      <PriceInput
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        name="SubTotalPrice"
                        label="مبلغ"
                        value={detailPriceData?.SubTotalPrice + ""}
                        round={false}
                        defaultValue={
                          detailPriceData?.SubTotalPrice ||
                          detailPriceData?.SubTotalPrice == 0
                            ? detailPriceData?.SubTotalPrice + ""
                            : ""
                        }
                        resetForm={resetForm}
                        mode={"view"}
                        required={false}
                      />
                    </div>
                  )}
                </div>
                {OrderConstraint?.IsFiscal && (
                  <>
                    <div className="row justify-content-end">
                      <div className="col-md-2">
                        {/* <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName="DiscountPercent"
                        textboxType="text"
                        useTrans={false}
                        labelText={trans("DiscountPercent")+'%'}
                        value={detailPriceData?.DiscountPercent + ""}
                        onChange={(e) =>
                          setDetailPriceData({
                            ...detailPriceData,
                            DiscountPercent: +e.target.value,
                            Discount:
                              (+e.target.value *
                                detailPriceData?.SubTotalPrice) /
                              100,
                            Price:
                              detailPriceData?.SubTotalPrice -
                              (+e.target.value *
                                detailPriceData?.SubTotalPrice) /
                                100,
                          })
                        }
                        defaultValue={
                          detailPriceData?.DiscountPercent > 0
                            ? detailPriceData?.DiscountPercent
                            : detailPriceData?.DiscountPercent == 0
                            ? 0
                            : null
                        }
                        max={100}
                        resetForm={resetForm}
                        mode={"view"}
                        useGroupingPrice={true}
                        required={false}
                      /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="DiscountPercent"
                          useTrans={false}
                          label={trans("DiscountPercent") + "%"}
                          value={detailPriceData?.DiscountPercent + ""}
                          onChange={(e) =>
                            setDetailPriceData({
                              ...detailPriceData,
                              DiscountPercent: +e.target.value,
                              Discount:
                                (+e.target.value *
                                  detailPriceData?.SubTotalPrice) /
                                100,
                              TotalPrice:
                                detailPriceData?.SubTotalPrice -
                                (+e.target.value *
                                  detailPriceData?.SubTotalPrice) /
                                  100,
                            })
                          }
                          defaultValue={
                            detailPriceData?.DiscountPercent > 0
                              ? detailPriceData?.DiscountPercent
                              : detailPriceData?.DiscountPercent == 0
                              ? 0
                              : null
                          }
                          max={100}
                          resetForm={resetForm}
                          mode={"view"}
                          required={false}
                        />
                      </div>
                      <div className="col-md-3">
                        {/* <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName="Discount"
                        textboxType="text"
                        labelText="Discount"
                        value={detailPriceData?.Discount * rate}
                        defaultValue={
                          (detailPriceData?.Discount
                            ? detailPriceData?.Discount
                            : null) *
                            rate +
                          ""
                        }
                        resetForm={resetForm}
                        round={false}
                        onChange={(e) => {
                          setDetailPriceData({
                            ...detailPriceData,
                            Price:
                              detailPriceData?.SubTotalPrice -
                              +e.target.value.replaceAll(",", ""),
                            UnitDiscount: +e.target.value.replaceAll(",", ""),
                            DiscountPercent:
                              (+e.target.value.replaceAll(",", "") /
                                detailPriceData?.SubTotalPrice) *
                              100,
                          });
                        }}
                        mode={"view"}
                        useGroupingPrice={true}
                        required={false}
                      /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="Discount"
                          label="Discount"
                          value={detailPriceData?.Discount * rate}
                          defaultValue={
                            (detailPriceData?.Discount
                              ? detailPriceData?.Discount
                              : null) *
                              rate +
                            ""
                          }
                          resetForm={resetForm}
                          round={false}
                          onChange={(e) => {
                            setDetailPriceData({
                              ...detailPriceData,
                              TotalPrice:
                                detailPriceData?.SubTotalPrice -
                                +e.target.value.replaceAll(",", ""),
                              UnitDiscount: +e.target.value.replaceAll(",", ""),
                              DiscountPercent:
                                (+e.target.value.replaceAll(",", "") /
                                  detailPriceData?.SubTotalPrice) *
                                100,
                            });
                          }}
                          mode={"view"}
                          required={false}
                        />
                      </div>
                      <div className="w-100"></div>
                         
                                            <div className="row justify-content-end">
                                             
                                            <div className="col-lg-3">
                                        
                                              <PriceInput
                                                Change={(e) => {
                                                  setUserChanges({ ...userChanges, ...e });
                                                }}
                                                name="Price2"
                                                label="totalprice"
                                                value={
                                                  detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                                                }
                                                defaultValue={detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                                                }
                                                resetForm={resetForm}
                                                // decimals={currency?.PriceRoundingPlace}
                                                round={false}
                                                mode={ "view"   }
                                              />
                                            </div>
                                            <div className="w-100"></div>
                                              <div className="col-lg-2">
                                              <Textbox
                                                Change={(e) => {
                                                  setUserChanges({ ...userChanges, ...e });
                                                }}
                                                textboxName="CustomerDiscountPercent"
                                                textboxType="number"
                                                customClass={'arrow-none'}
                                                useTrans={false}
                                                labelText={trans("CustomerDiscountPercent")+'%'}
                                                value={detailPriceData?.CustomerDiscountPercent + ""}
                                                max={100}
                                                min={0}
                                                defaultValue={
                                                  detailPriceData?.CustomerDiscountPercent
                                                    ? detailPriceData.CustomerDiscountPercent + ""
                                                    : detailPriceData?.CustomerDiscountPercent == 0
                                                    ? "0"
                                                    : ""
                                                }
                                                resetForm={resetForm}
                                                mode={ "view"}
                                              />
                                            </div>
                                            <div className="col-lg-3">
                                              {/* <Textbox
                                                Change={(e) => {
                                                  setUserChanges({ ...userChanges, ...e });
                                                }}
                                                textboxName="CustomerDiscount"
                                                textboxType="text"
                                                labelText="CustomerDiscount" 
                                                value={detailPriceData.CustomerDiscount}
                                                defaultValue={detailPriceData.CustomerDiscount+''}
                                                resetForm={resetForm}
                                                decimals={currency?.PriceRoundingPlace}
                                                round={false}
                                                mode={"view" }
                                                useGroupingPrice={true}
                                              /> */}
                                              <PriceInput
                                               Change={(e) => {
                                                  setUserChanges({ ...userChanges, ...e });
                                                }}
                                                name="CustomerDiscount"
                                                label="CustomerDiscount" 
                                                value={detailPriceData.CustomerDiscount}
                                                defaultValue={detailPriceData.CustomerDiscount+''}
                                                resetForm={resetForm}
                                                // decimals={currency?.PriceRoundingPlace}
                                                round={false}
                                                mode={"view" }
                                              />
                                            </div>
                                            </div>
                                            
                      <div className="w-100"></div>

                      <div className="col-md-3">
                        {/* <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName="Price"
                        textboxType="text"
                        labelText="totalprice"
                        value={detailPriceData.Price + ""}
                        defaultValue={detailPriceData?.Price}
                        resetForm={resetForm}
                        decimals={OrderConstraint?.PriceRoundingPlace}
                        round={false}
                        mode={
                          priceList?.IsManual && mode != "view"
                            ? "create"
                            : "view"
                        }
                        useGroupingPrice={true}
                        required={false}
                      /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="TotalPrice"
                          label="TotalPrice"
                          value={detailPriceData.TotalPrice + ""}
                          defaultValue={detailPriceData?.TotalPrice}
                          resetForm={resetForm}
                          decimals={OrderConstraint?.PriceRoundingPlace}
                          round={false}
                          mode={
                            priceList?.IsManual && mode != "view"
                              ? "create"
                              : "view"
                          }
                          required={false}
                        />
                      </div>
                    </div>

                    <div className="row justify-content-end">
                      <div className="col-md-2">
                        {/* <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName="TaxRate"
                        textboxType="text"
                        useTrans={false}
                        labelText={trans('TaxRate')+'%'}
                        value={  (OrderConstraint.HasTax  && mode!='view') || mode=='view' &&   detailPriceData?.TaxRate
                          ?  detailPriceData?.TaxRate
                        
                          : 0}
                       
                        defaultValue={
                          (OrderConstraint.HasTax  && mode!='view') || mode=='view' &&   detailPriceData?.TaxRate
                            ?  detailPriceData?.TaxRate
                          
                            : 0
                        }
                        max={100}
                        resetForm={resetForm}
                        mode={"view"}
                        useGroupingPrice={true}
                        required={false}
                      /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="TaxRate"
                          useTrans={false}
                          label={trans("TaxRate") + "%"}
                          value={
                            (OrderConstraint.HasTax && mode != "view") ||
                            (mode == "view" && detailPriceData?.TaxRate)
                              ? detailPriceData?.TaxRate
                              : 0
                          }
                          defaultValue={
                            (OrderConstraint.HasTax && mode != "view") ||
                            (mode == "view" && detailPriceData?.TaxRate)
                              ? detailPriceData?.TaxRate
                              : 0
                          }
                          max={100}
                          resetForm={resetForm}
                          mode={"view"}
                          required={false}
                        />
                      </div>
                      <div className="col-md-3">
                        {/* <Textbox
                        useGroupingPrice
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName="Tax"
                        textboxType="text"
                        labelText="Tax"
                        decimals={OrderConstraint?.PriceRoundingPlace}
                        round={OrderConstraint?.FloorTaxDuty}
                        defaultValue={
                          OrderConstraint?.HasTax &&   detailPriceData?.TaxRate
                            ?OrderConstraint?.FloorTaxDuty?FloorWithRoundingPlace(
                              (+detailPriceData.TaxRate *
                                +detailPriceData.Price) /
                                100,
                              OrderConstraint?.PriceRoundingPlace,
                              
                            ) + "": RoundWithRoundingPlace(
                                (+detailPriceData.TaxRate *
                                  +detailPriceData.Price) /
                                  100,
                                OrderConstraint?.PriceRoundingPlace,
                                
                              ) + ""
                            : "0"
                        }
                        value={
                          OrderConstraint?.HasTax&&     detailPriceData?.TaxRate
                            ?  OrderConstraint?.FloorTaxDuty?FloorWithRoundingPlace(
                              (+detailPriceData.TaxRate *
                                +detailPriceData.Price) /
                                100,
                              OrderConstraint?.PriceRoundingPlace,
                            
                            ) + "": RoundWithRoundingPlace(
                                (+detailPriceData.TaxRate *
                                  +detailPriceData.Price) /
                                  100,
                                OrderConstraint?.PriceRoundingPlace,
                              
                              ) + ""
                            : "0"
                        }
                        resetForm={resetForm}
                        mode={
                       
                             "view"
                        }
                        required={false}
                        // onChange={(e) => {
                        //   if (priceList.IsManual) {
                        //     setDetailPriceData({
                        //       ...detailPriceData,
                        //       TaxRate:
                        //         (+e.target.value.replaceAll(",", "") * 100) /
                        //         detailPriceData.Price,
                        //     });
                        //   }
                        // }}
                      /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="Tax"
                          label="Tax"
                          decimals={OrderConstraint?.PriceRoundingPlace}
                          round={OrderConstraint?.FloorTaxDuty}
                          defaultValue={
                            OrderConstraint?.HasTax && detailPriceData?.TaxRate
                              ? OrderConstraint?.FloorTaxDuty
                                ? FloorWithRoundingPlace(
                                    (+detailPriceData.TaxRate *
                                      +detailPriceData.TotalPrice) /
                                      100,
                                    OrderConstraint?.PriceRoundingPlace
                                  ) + ""
                                : RoundWithRoundingPlace(
                                    (+detailPriceData.TaxRate *
                                      +detailPriceData.TotalPrice) /
                                      100,
                                    OrderConstraint?.PriceRoundingPlace
                                  ) + ""
                              : "0"
                          }
                          value={
                            OrderConstraint?.HasTax && detailPriceData?.TaxRate
                              ? OrderConstraint?.FloorTaxDuty
                                ? FloorWithRoundingPlace(
                                    (+detailPriceData.TaxRate *
                                      +detailPriceData.TotalPrice) /
                                      100,
                                    OrderConstraint?.PriceRoundingPlace
                                  ) + ""
                                : RoundWithRoundingPlace(
                                    (+detailPriceData.TaxRate *
                                      +detailPriceData.TotalPrice) /
                                      100,
                                    OrderConstraint?.PriceRoundingPlace
                                  ) + ""
                              : "0"
                          }
                          resetForm={resetForm}
                          mode={"view"}
                          required={false}
                        />
                      </div>
                    </div>

                    <div className="row justify-content-end">
                      <div className="col-md-3">
                        {/* <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName="GrandTotalPrice"
                        textboxType="text"
                        labelText="payableamount"
                        value={detailPriceData?.UnitPrice==-1?0:
                          detailPriceData?.TaxRate
                            ? +detailPriceData.Price +
                              (+detailPriceData?.TaxRate *
                                +detailPriceData?.Price) /
                                100 +
                              ""
                            : detailPriceData?.Price
                            ? detailPriceData?.Price + ""
                            : ""
                        }
                        defaultValue={detailPriceData?.UnitPrice==-1?0:
                          detailPriceData?.TaxRate
                            ? +detailPriceData.Price +
                              (+detailPriceData?.TaxRate *
                                +detailPriceData?.Price) /
                                100 +
                              ""
                            : detailPriceData?.Price
                            ? detailPriceData?.Price + ""
                            : ""
                        }
                        resetForm={resetForm}
                        decimals={OrderConstraint?.PriceRoundingPlace}
                        round={false}
                        mode={
                          priceList?.IsManual && mode != "view"
                            ? "create"
                            : "view"
                        }
                        useGroupingPrice={true}
                        required={false}
                      /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="GrandTotalPrice"
                          label="payableamount"
                          value={
                            detailPriceData?.UnitPrice == -1
                              ? 0
                              : detailPriceData?.TaxRate
                              ? +detailPriceData.TotalPrice +
                                (+detailPriceData?.TaxRate *
                                  +detailPriceData?.TotalPrice) /
                                  100 +
                                ""
                              : detailPriceData?.TotalPrice
                              ? detailPriceData?.TotalPrice + ""
                              : ""
                          }
                          defaultValue={
                            detailPriceData?.UnitPrice == -1
                              ? 0
                              : detailPriceData?.TaxRate
                              ? +detailPriceData.TotalPrice +
                                (+detailPriceData?.TaxRate *
                                  +detailPriceData?.TotalPrice) /
                                  100 +
                                ""
                              : detailPriceData?.TotalPrice
                              ? detailPriceData?.TotalPrice + ""
                              : ""
                          }
                          resetForm={resetForm}
                          decimals={OrderConstraint?.PriceRoundingPlace}
                          round={false}
                          mode={
                            priceList?.IsManual && mode != "view"
                              ? "create"
                              : "view"
                          }
                          required={false}
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className="row justify-content-end"></div>

                <div className="col-md-12">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxType="textarea"
                    textboxName="Description"
                    labelText="Description"
                    defaultValue={
                      mode != "create" ? selectedObj?.Description : null
                    }
                    resetForm={resetForm}
                    mode={mode}
                    required={false}
                  />
                </div>

                <>
                  {mode != "view" ? (
                    <div className="col-md-12 mt-1 btns_form">
                      <Button value="save" btnType="submit" />
                      <Button
                        value="SaveAndClose"
                        btnType="submit"
                        onClick={() => {
                          setSave_Exit(true);
                        }}
                      />
                      <Button
                        btnType="cancel"
                        value="Cancel"
                        onClick={() => {
                          cancel();
                        }}
                      />
                    </div>
                  ) : (
                    <div className="col-md-12 mt-1 btns_form">
                      <Button
                        btnType="primary"
                        value="close"
                        onClick={() => {
                          cancel();
                        }}
                      />
                    </div>
                  )}
                </>
              </form>
            </div>
          ) : (
            <Loading />
          )}
        </div>
        {!!priceListDetail.length &&
          OrderConstraint?.PriceListHasDetailRange &&
          mode == "create" && (
            <PriceDetails priceListDetail={priceListDetail} />
          )}
      </div>
    </div>
  );
};
